import { z } from 'zod';
import { avatarUrlSchema, nameSchema } from '@/utils/schemas';

export const contactMessageScheme = z.object({
  HeadImg: avatarUrlSchema,
  UserID: z.number().or(z.string()).pipe(z.coerce.number()),
  NickName: nameSchema,
  VChatID: z.string().nullish(),
});

export const inviteMessageScheme = z.object({
  MaxUserCount: z.number().or(z.string()).pipe(z.coerce.number()).nullish(),
  UserCount: z.number().or(z.string()).pipe(z.coerce.number()),
  GroupImg: avatarUrlSchema,
  JoinType: z
    .union([z.literal(0), z.literal(1), z.literal('0'), z.literal('1')])
    .pipe(z.coerce.number())
    .pipe(z.coerce.boolean()),
  GroupID: z.number().or(z.string()).pipe(z.coerce.number()),
  Info: z.string().nullish(),
  GroupName: nameSchema,
});

export type ContactMessageType = z.infer<typeof contactMessageScheme>;

export type InviteMessageType = z.infer<typeof inviteMessageScheme>;
